import React = require('react');
import ReactDOM = require('react-dom');
import 'core-js/es6/object';
import 'core-js/es6/promise';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { ContentBySearchContainer } from './components/container/ContentBySearchContainer';
import { rootReducer } from './store/reducers';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { IReactDomConfig, AppLauncher } from 'pintra-fx';

// import './style/font-awesome.css';
import './style/font-awesome.min.css';
import './style/wpo.ui.css';

const reactDomConfig: IReactDomConfig = AppLauncher.getReactDomConfig();

/**
 * Initialize the Redux store and fill initial data
 */
const store = createStore(rootReducer, applyMiddleware(thunk, logger));

/**
 * Bootstrap the app
 */
ReactDOM.render(
  <Provider store={store}>
    <ContentBySearchContainer env={reactDomConfig.env} />
  </Provider>,
  document.getElementById(reactDomConfig.rootId)
);
